export default function SvgRewards() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g>
        <path
          d="M36 12.0039H4C2.89543 12.0039 2 12.8992 2 14.0037V18.0033C2 19.1078 2.89543 20.0031 4 20.0031H36C37.1046 20.0031 38 19.1078 38 18.0033V14.0037C38 12.8992 37.1046 12.0039 36 12.0039Z"
          fill="none"
          stroke="#0054A9"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 12.0039V38.0013"
          fill="none"
          stroke="#0054A9"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 19.998V33.9966C34 35.0574 33.5786 36.0747 32.8284 36.8248C32.0783 37.5748 31.0609 37.9962 30 37.9962H10C8.93913 37.9962 7.92172 37.5748 7.17157 36.8248C6.42143 36.0747 6 35.0574 6 33.9966V19.998"
          fill="none"
          stroke="#0054A9"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 11.9999C9.67392 11.9999 8.40215 11.4731 7.46447 10.5355C6.52678 9.59796 6 8.32632 6 7.00037C6 5.67442 6.52678 4.40278 7.46447 3.46519C8.40215 2.52761 9.67392 2.00087 11 2.00087C12.9294 1.96726 14.82 2.9033 16.4255 4.68692C18.0309 6.47055 19.2766 9.01897 20 11.9999C20.7234 9.01897 21.9691 6.47055 23.5745 4.68692C25.1799 2.9033 27.0706 1.96726 29 2.00087C30.3261 2.00087 31.5978 2.52761 32.5355 3.46519C33.4732 4.40278 34 5.67442 34 7.00037C34 8.32632 33.4732 9.59796 32.5355 10.5355C31.5978 11.4731 30.3261 11.9999 29 11.9999"
          fill="none"
          stroke="#0054A9"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
}
